import angular from 'angular'

angular.module('vend.ui').directive('vdExpandable', function () {
  return {
    restrict: 'A',
    scope: {
      isExpanded: '=?',
    },
    link($scope, $element, $attrs) {
      $attrs.$addClass('vd-expandable')
    },
    controller($scope, $element, $timeout) {
      const CHEVRON_RIGHT_CLASS = 'fa-angle-right'
      const CHEVRON_DOWN_CLASS = 'fa-angle-down'
      const EXPANDED_ROW_CLASS = 'vd-expandable--expanded'
      const EXPANDABLE_CHEVRON_CLASS = '.vd-expandable-chevron'

      $scope.isExpanded = angular.isDefined($scope.isExpanded)
        ? $scope.isExpanded
        : false

      /**
       * Set the state of the row to collapsed or expanded
       *
       * @private
       * @param {Boolean} isExpanded
       *        True if the row is now expanded
       */
      const _setRowState = isExpanded => {
        const chevron = angular.element(
          $element[0].querySelector(EXPANDABLE_CHEVRON_CLASS)
        )

        $scope.isExpanded = isExpanded
        $element.toggleClass(EXPANDED_ROW_CLASS, isExpanded)
        chevron
          .toggleClass(CHEVRON_RIGHT_CLASS, !isExpanded)
          .toggleClass(CHEVRON_DOWN_CLASS, isExpanded)
      }

      /**
       * Adds or removes the vd-expandable--expanded class from the element
       *
       * @method toggleExpandedContent
       */
      this.toggleExpandedContent = () => {
        const isExpanded = !$element.hasClass(EXPANDED_ROW_CLASS)
        _setRowState(isExpanded)
      }

      $scope.$watch('isExpanded', isExpanded => _setRowState(isExpanded))

      // Ensure child component is loaded before manipulating the class
      $timeout(() => {
        _setRowState($scope.isExpanded)
      })
    },
  }
})
